import React from 'react';
import { Typography } from '@mui/material';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import Card from 'components/shared/Card';
import { TechnicalIssue } from 'store/types/Meeting';

interface TechnicalIssueViewCardProps {
  technicalIssue: TechnicalIssue;
}

const TechnicalIssueViewCard: React.FunctionComponent<TechnicalIssueViewCardProps> = ({ technicalIssue }) => {
  return (
    <Card title={<Typography variant="h6">Other Technical Issue</Typography>} bordered>
      <GridContainer spacing={1}>
        <GridItem md={2}>
          <Typography>
            <strong>Origin:</strong>
          </Typography>
        </GridItem>
        <GridItem md={10}>
          <Typography>{technicalIssue.origin}</Typography>
        </GridItem>

        <GridItem md={2}>
          <Typography>
            <strong>Referenced Section:</strong>
          </Typography>
        </GridItem>
        <GridItem md={10}>
          <Typography>{technicalIssue.reference}</Typography>
        </GridItem>

        <GridItem md={2}>
          <Typography>
            <strong>Reason:</strong>
          </Typography>
        </GridItem>
        <GridItem md={10}>
          <Typography>{technicalIssue.reason}</Typography>
        </GridItem>
      </GridContainer>
    </Card>
  );
};

export default TechnicalIssueViewCard;
